import { FaFacebook, FaLinkedin } from 'react-icons/fa';
import { FaPhoneVolume } from 'react-icons/fa6';
import { IoLogoYoutube } from 'react-icons/io5';
import { RiTwitterXLine, RiWechatFill } from 'react-icons/ri';
import '../../css/Root.css';

const TopHeader = () => {
  return (
    <div>
      <div className='bg-[#1F2C30] py-3'>
        <div className='px-4 md:px-24 lg:px-14 mx-auto sm:max-w-full md:max-w-full lg:max-w-screen'>
          <div className='flex items-center justify-between flex-wrap'>
            <div className='flex items-center gap-1 sm:gap-5 flex-wrap justify-center'>
              <div className='text-white flex items-center gap-2.5'>
                <FaPhoneVolume />
                <a className='font-medium text-[15px]' href='tel:01345336969'>
                  +8801345-336969
                </a>
              </div>
              <div className='text-white flex items-center gap-2.5'>
                <RiWechatFill />
                <a
                  className='font-medium text-[15px]'
                  href='mailto:msolaimantechnicalcenter@gmail.com'
                >
                  msolaimantechnicalcenter@gmail.com
                </a>
              </div>
            </div>
            <div className='text-white hidden sm:flex items-center gap-5'>
              <span className='font-medium'>Follow us:</span>
              <div className='flex items-center gap-2.5'>
                <a
                  target='_blank'
                  href='https://www.facebook.com/share/1aHKmZoTac/'
                  className='text-white hover:text-primary'
                  rel='noreferrer'
                >
                  <FaFacebook />
                </a>
                <a
                  target='_blank'
                  href='https://x.com/'
                  className='text-white hover:text-primary'
                  rel='noreferrer'
                >
                  <RiTwitterXLine />
                </a>
                <a
                  target='_blank'
                  href='https://www.linkedin.com/'
                  className='text-white hover:text-primary'
                  rel='noreferrer'
                >
                  <FaLinkedin />
                </a>
                <a
                  target='_blank'
                  href='https://www.youtube.com/'
                  className='text-white hover:text-primary'
                  rel='noreferrer'
                >
                  <IoLogoYoutube />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
